<template>
  <hr-dialog title="新增巡检项" :visible.sync="visible" width="50%">
    <template slot="body">
      <el-form :model="form" ref="FormRef" :rules="formRules" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="巡检项名称" prop="name">
              <el-input
                clearable
                v-model="form.name"
                placeholder="请输入 巡检项名称"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参考下限" prop="valueRangeMin">
              <el-input
                clearable
                v-model="form.valueRangeMin"
                @keydown.native="handleInput"
                @input="
                  (e) => {
                    regValue(e, form, 'valueRangeMin');
                  }
                "
                @blur="inputBlur(form, 'valueRangeMin')"
                placeholder="请输入 参考下限"
                maxlength="12"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="参考上限" prop="valueRangeMax">
              <el-input
                clearable
                type="number"
                v-model="form.valueRangeMax"
                @input="
                  (e) => {
                    regValue(e, form, 'valueRangeMax');
                  }
                "
                @blur="inputBlur(form, 'valueRangeMax')"
                placeholder="请输入 参考上限"
                maxlength="12"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参考标准" prop="valueDefault">
              <el-input
                type="number"
                clearable
                @input="
                  (e) => {
                    regValue(e, form, 'valueDefault');
                  }
                "
                @blur="inputBlur(form, 'valueDefault')"
                v-model="form.valueDefault"
                placeholder="请输入 参考标准"
                maxlength="12"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
    <template slot="footer">
      <div class="btnArea" style="text-align:right;margin-right:24px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="submitRecord"
          style="margin-right: 20px"
          >保存</el-button
        >
        <el-button @click="closeRecord" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </template>
  </hr-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    dataList: [],
    operatorModle: 'add',
    row: {},
  },
  data() {
    var maxAndminValidate = (rule, value, callback) => {
      let min = this.form.valueRangeMin;
      let max = this.form.valueRangeMax;
      let defaultValue = this.form.valueDefault;
      if (min&&max) {
        if (Number(max) >=Number(min) ) {
          this.$refs.FormRef.clearValidate("valueRangeMax")
          this.$refs.FormRef.clearValidate("valueRangeMin")
          if(defaultValue){//清空默认的验证
            if(Number(defaultValue)>=Number(min)&&Number(defaultValue)<=Number(max)){
               this.$refs.FormRef.clearValidate("valueDefault")
            }
          }
          callback();
        } else {
          callback(new Error('参考上限必须大于参考下限'));
        }
      }
    };
    var valueDefaultValidate = (rule, value, callback) =>{
      console.log("chu发了验证")
      let min = this.form.valueRangeMin;
      let max = this.form.valueRangeMax;
      let defaultValue = this.form.valueDefault;
        if(value&&min&&max){
          if(Number(defaultValue)>=Number(min)&&Number(defaultValue)<=Number(max)){
                callback()
            }else{
              callback(new Error('参考标准必须在参考下限和参考上限范围内'))
            }
        }else{
          callback()
        }
    }
    return {
      form: {
        name: '',
        valueRangeMin: '',
        valueRangeMax: '',
        valueDefault: '',
      },
      oldValue: '',
      formRules: {
        name: [{ required: true, message: '巡检项名称不能为空！', trigger: 'blur' }],
        valueRangeMin: [
          { required: true, message: '参考下限不能为空！', trigger: 'blur' },
          { validator: maxAndminValidate, trigger: 'blur' },
        ],
        valueRangeMax: [
          { required: true, message: '参考上限不能为空！', trigger: 'blur' },
          { validator: maxAndminValidate, trigger: 'blur' },
        ],
        valueDefault:[
           { validator: valueDefaultValidate, trigger: 'blur' },
        ]
      },
    };
  },
  watch: {
    visible() {
      console.log('chufa');
      this.$emit('update:visible', this.visible);
    },
  },
  created() {
    console.log('111', this.dataList);
    if (this.operatorModle == 'view') {
      for (const key in this.row) {
        this.form[key] = this.row[key];
      }
    }
  },
  methods: {
    closeRecord() {
      this.visible = false;
    },
    submitRecord() {
      this.$refs['FormRef'].validate((value) => {
        if (value) {
          if (this.operatorModle != 'view') {
            // this.$emit('getInspectItem', this.form);
            console.log(this.dataList);
            this.dataList.push(this.form);
          } else {
            console.log('oldRow', this.row);
            for (const key in this.form) {
              this.row[key] = this.form[key];
            }

            console.log('newRow', this.row);
          }
          this.$set(this, 'visible', false);
          this.$emit('update:visible', false);
          //  this.visible = false
          console.log('chufalesubdsad2345', this.visible);
        }
      });
    },
    regValue(value, obj, field) {
      if (obj[field] + '') {
        // obj[field] = obj[field].replace(/[^(\d|.|\-)]/g,'')
        // let reg = /^-?([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
        let reg = /^(-?)\d{1,9}(\.\d{0,2})?$/;
        if (reg.test(obj[field])) {
          this.oldValue = value;
          console.log('old', this.oldValue);
        } else {
          if (obj[field] == '-' || !obj[field]) {
            obj[field] = obj[field];
          } else {
            let length = (obj[field] + '').length;

            if (length == 1) {
              obj[field] = '';
            } else {
              obj[field] = this.oldValue;
            }
          }
        }
      }
    },
    inputBlur(value, field) {
      if (value[field] + '') {
        value[field] = Number(value[field]);
        value[field] = value[field].toFixed(2);
      }

      console.log(value[field]);
    },
    handleInput(e) {
      // console.log(e.target.value)
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-12{
  height: 54px;
}
</style>
